export class WebSocketOptions<T = any> {
    autoConnect?: boolean;
    url?: string;
    options?: T;
}
